// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Spinner_SpinnerContainer_25yzX {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.Spinner_Spinner_1fiyk {\n  height: 70px;\n  width: 70px;\n  animation: Spinner_spin_kjb3w 0.7s infinite linear;\n  border-color: transparent #76b900 #76b900;\n  border-width: 5px;\n  border-style: solid;\n  border-radius: 50%;\n}\n\n@keyframes Spinner_spin_kjb3w {\n  0% {\n    transform: rotate(0);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n", ""]);
// Exports
exports.locals = {
	"SpinnerContainer": "Spinner_SpinnerContainer_25yzX",
	"Spinner": "Spinner_Spinner_1fiyk",
	"spin": "Spinner_spin_kjb3w"
};
module.exports = exports;
